import React, { Fragment, useEffect, useRef, useState } from "react";
import { DeleteIcon, EditIcon } from "../../../../assets/icons/index";
import StandardTestPopup from "./standardTestPopup";
import StandardCardSortableItem from "./standardCardSortableItem";
import { deleteLFDiagnosticTest } from "../../../../api/liftOffDiagnosticTest.service";
import { updateLFDiagnosticTestQuestion } from "../../../../api/liftOffDiagnosticTestQuestion.service";
import DeleteModal from "../../../shared/common/deleteModal";
import {
  deleteLFDiagnosticTestQuestion,
  getLFDiagnosticTestQuestion,
} from "../../../../api/liftOffDiagnosticTestQuestion.service";
import {
  ILiftOffDiagnosticTest,
  ILiftOffDiagnosticTestQuestionDTO,
  ILiftOffDiagnosticTestQuestion,
} from "../../../../model/interface/liftOffDiagnosticTest";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import Loader from "../../../shared/loader/loader";
import { connect } from "react-redux";
import GalaxyPopup from "../galaxyTab/galaxyPopup";
import { ILiftOffGalaxyTopic } from "../../../../model/interface/liftOffGalaxyStandard";
import {
  IStandardGroupStandardDTO,
  IStandardGroupStandardSearchRequest,
} from "../../../../model/interface/standardGroup";
import { getStandardGroupStandards } from "../../../../api/standardGroup.service";

interface StandardCardProps extends ILiftOffDiagnosticTest {
  number?: number;
  isStandardCardSelected: boolean;
  profile: any;
  onClicked: (lfDiagTestId: number) => void;
  saveTest: (data: any) => void;
  setIsReload: (isReload: boolean) => void;
  isReload: boolean;
}

const StandardCard = (props: StandardCardProps) => {
  const defaultTestQuestion: ILiftOffDiagnosticTestQuestionDTO = {
    liftOffDiagTestQuestionId: 0,
    liftOffDiagnosticTestID: props.liftOffDiagnosticTestId,
    standardReferenceId: 0,
    isStandardGroup: false,
    standardCode: "",
    testName: props.name,
    standard: "",
    gradeId: 0,
    grade: "",
    questionId1: 0,
    questionId2: 0,
    orderNumber: 0,
    isActive: true,
    createdByUserId: 0,
  };

  const defaultPageNumber = 1;
  const defaultPageSize = 9999;
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [showSaveOrderFlag, setShowSaveOrderFlag] = useState(false);
  const [pageSize] = useState(defaultPageSize);
  const [pageNumber] = useState(defaultPageNumber);
  const [showStandardTestPopup, setShowStandardTestPopup] = useState(false);
  const [deleteQuestion, setDeleteQuestion] = useState<any>();
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedlfDiagTestQuestion, setLFDiagTestQuestion] =
    useState<ILiftOffDiagnosticTestQuestionDTO>(defaultTestQuestion);
  const [lfDiagTestQuestions, setLFDiagTestQuestions] = useState<
    Array<ILiftOffDiagnosticTestQuestionDTO>
  >([]);
  const [showGalaxyPopup, setShowGalaxyPopup] = useState(false);
  const [showDeleteTestModal, setShowDeleteTestModal] = useState(false);
  const [selectedStandards, setSelectedStandards] = useState<
    Array<ILiftOffGalaxyTopic>
  >([]);
  const [toggle, setToggle] = useState<number>();
  const [groupedStandards, setGroupedStandards] = useState<
    Array<IStandardGroupStandardDTO>
  >([]);
  const paginationRef: any = useRef(undefined);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  useEffect(() => {
    if (!showGalaxyPopup) {
      getData(props.liftOffDiagnosticTestId, props.liftOffHeaderId);
    }
  }, [
    props.liftOffHeaderId,
    props.isStandardCardSelected,
    pageNumber,
    showGalaxyPopup,
  ]);

  const getData = (testId: number, headerId: number) => {
    if (props.isStandardCardSelected) {
      setLoading(true);
      getLFDiagnosticTestQuestion(testId, headerId, pageNumber, pageSize)
        .then((r) => {
          setLoading(false);
          setLFDiagTestQuestions(r.data.data);
          setTotalPages(Math.ceil(r.data.totalRecords / pageSize));
          setTotalRecords(r.data.totalRecords);
          const lfGalaxydata: Array<ILiftOffGalaxyTopic> = [];
          r.data.data.map((item, index) => {
            const liftOffGalaxyTopic: ILiftOffGalaxyTopic = {
              liftOffHeaderId: props.liftOffHeaderId,
              liftOffGalaxyId: props.number ?? 0,
              state: "",
              gradeId: item.gradeId,
              grade: item.grade,
              isStandardGrouped: item.isStandardGroup,
              orderNumber: item.orderNumber,
              standardName: item.standard,
              standardId: item.standardReferenceId,
              code: item.standardCode,
            };
            lfGalaxydata.push(liftOffGalaxyTopic);
          });

          setSelectedStandards(lfGalaxydata);
        })
        .catch((r) => {
          setLoading(false);
        });
    }
  };

  const handleAddQuestion = () => {
    const question = defaultTestQuestion;
    question.testName =
      lfDiagTestQuestions.length > 0
        ? lfDiagTestQuestions[0].testName
        : props.name;
    setLFDiagTestQuestion(question);
    setShowStandardTestPopup(true);
  };

  const handleAddGalaxyStandard = async () => {
    if (lfDiagTestQuestions.length === 0 && props.liftOffDiagnosticTestId > 0) {
      getLFDiagnosticTestQuestion(
        props.liftOffDiagnosticTestId,
        props.liftOffHeaderId,
        pageNumber,
        pageSize
      ).then((r) => {
        setLFDiagTestQuestions(r.data.data);
        setTotalPages(Math.ceil(r.data.totalRecords / pageSize));
        setTotalRecords(r.data.totalRecords);
        const lfGalaxydata = r.data.data.map((item, index) => {
          const liftOffGalaxyTopic: ILiftOffGalaxyTopic = {
            liftOffHeaderId: props.liftOffHeaderId,
            liftOffGalaxyId: props.number ?? 0,
            state: "",
            gradeId: item.gradeId,
            grade: item.grade,
            isStandardGrouped: item.isStandardGroup,
            orderNumber: item.orderNumber,
            standardName: item.standard,
            standardId: item.standardReferenceId,
            code: item.standardCode,
          };

          return liftOffGalaxyTopic;
        });
        setSelectedStandards(lfGalaxydata);
        setShowGalaxyPopup(true);
      });
    } else {
      setShowGalaxyPopup(true);
    }
  };

  const handleSaveQuestion = (data: any) => {
    props.saveTest(data);
    setShowStandardTestPopup(false);
    setShowGalaxyPopup(false);
  };

  const confirmDeleteQuestion = (lfDiagtestQuestionId) => {
    setShowDeleteModal(true);
    const question: any = lfDiagTestQuestions.find(
      (question: any) =>
        question.liftOffDiagTestQuestionId === lfDiagtestQuestionId
    );
    setDeleteQuestion(question);
  };

  const handleDeleteQuestion = () => {
    setLoading(true);
    deleteLFDiagnosticTestQuestion(
      deleteQuestion.liftOffDiagTestQuestionId,
      props.profile?.userId
    )
      .then((r) => {
        if (lfDiagTestQuestions.length === 1) {
          paginationRef?.current?.onReset();
        } else {
          getData(props.liftOffDiagnosticTestId, props.liftOffHeaderId);
        }
        setShowDeleteModal(false);
        setLoading(false);
      })
      .catch((r) => {
        setShowDeleteModal(false);
        setLoading(false);
      });
  };

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (!over || lfDiagTestQuestions.length <= 1) return;

    if (active.id !== over.id) {
      const oldIndex = lfDiagTestQuestions.findIndex(
        (item) => item.liftOffDiagTestQuestionId.toString() === active.id
      );
      const newIndex = lfDiagTestQuestions.findIndex(
        (item) => item.liftOffDiagTestQuestionId.toString() === over.id
      );

      const newItems = arrayMove(lfDiagTestQuestions, oldIndex, newIndex);
      setLFDiagTestQuestions(newItems);
      setShowSaveOrderFlag(true);
    }
  };

  const handleSaveOrder = () => {
    setLoading(true);

    const lfDiagTestQuestionsData = lfDiagTestQuestions.map((item, index) => {
      const data: ILiftOffDiagnosticTestQuestion = {
        liftOffDiagTestQuestionId: item.liftOffDiagTestQuestionId,
        liftOffDiagnosticTestID: item.liftOffDiagnosticTestID,
        standardReferenceId: item.standardReferenceId,
        isStandardGroup: item.isStandardGroup,
        gradeId: item.gradeId,
        grade: "",
        questionId1: item.questionId1,
        questionId2: item.questionId2,
        orderNumber: pageSize * (pageNumber - 1) + index + 1,
        isActive: item.isActive,
        createdByUserId: props.profile?.userId,
      };
      return data;
    });

    updateLFDiagnosticTestQuestion(lfDiagTestQuestionsData)
      .then((r) => {
        setLoading(false);
        setShowSaveOrderFlag(false);
        getData(props.liftOffDiagnosticTestId, props.liftOffHeaderId);
      })
      .catch((e) => {
        setLoading(false);
        setShowSaveOrderFlag(false);
      });
  };

  const confirmDeleteTest = (lfDiagtestId) => {
    setShowDeleteTestModal(true);
  };

  const handleDeleteTest = () => {
    setLoading(true);
    deleteLFDiagnosticTest(props.liftOffDiagnosticTestId, props.profile?.userId)
      .then((r) => {
        props.setIsReload(!props.isReload);
        setShowDeleteTestModal(false);
        setLoading(false);
      })
      .catch((r) => {
        setShowDeleteTestModal(false);
        setLoading(false);
      });
  };

  const handleShowGroupedStandards = async (standardGroupId, index?, type?) => {
    setLoading(true);
    if (type === "show") {
      const groupStandardSearchReq: IStandardGroupStandardSearchRequest = {
        standardGroupId: standardGroupId,
        standardId: 0,
        isActive: true,
      };
      const response = getStandardGroupStandards(
        groupStandardSearchReq,
        1,
        99999
      );
      const data = (await response).data;
      setGroupedStandards(data.data);
      setToggle(index);
    } else {
      setToggle(undefined);
    }
    setLoading(false);
  };

  return (
    <Fragment>
      {showGalaxyPopup && (
        <GalaxyPopup
          liftOffHeaderId={props.liftOffHeaderId}
          showPopup={setShowGalaxyPopup}
          selectedStandards={selectedStandards}
          subjectId={props.subjectId}
          liftOffDiagnosticTestID={props.liftOffDiagnosticTestId}
          testName={props.name}
          lfDiagTestQuestions={lfDiagTestQuestions}
          saveTest={props.saveTest}
        />
      )}
      <div
        className="mt-6 cursor-pointer bg-gray-50 sm:pr-6 lg:pr-8 lg:flex-shrink-0 lg:border-l lg:border-gray-200 xl:pr-0 shadow border border-gray-200 sm:rounded-lg m-auto"
        onClick={() => {
          props.onClicked(props.liftOffDiagnosticTestId);
        }}
      >
        {loading && <Loader></Loader>}
        <div className="p-4">
          <div className="mb-2 flex items-center justify-between">
            <h3>
              {lfDiagTestQuestions && lfDiagTestQuestions.length > 0
                ? lfDiagTestQuestions[0].testName
                : props.name}
            </h3>

            <div className="flex justify-end">
              <EditIcon
                className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                title="Edit Heirarchy"
                onClick={handleAddGalaxyStandard}
              />
              <DeleteIcon
                className="w-6 h-6"
                onClick={() => {
                  confirmDeleteTest(props.liftOffDiagnosticTestId);
                }}
              />
            </div>
          </div>
          {props.isStandardCardSelected && (
            <Fragment>
              <div className="flex-grow overflow-hidden rounded-lg">
                <DndContext
                  sensors={sensors}
                  collisionDetection={closestCenter}
                  onDragEnd={handleDragEnd}
                >
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-primary-color">
                      <tr>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                        >
                          <span className="flex">Action</span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                        >
                          <span className="flex"></span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                        >
                          <span className="flex">Order</span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                        >
                          <span className="flex">Code</span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                        >
                          <span className="flex">Standard</span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider"
                        >
                          <span className="flex">Grade</span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider"
                        >
                          <span className="flex">QuestionId 1</span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2  whitespace-nowrap font-light text-sm text-center text-white tracking-wider"
                        >
                          <span className="flex">QuestionId 2</span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider"
                        >
                          <span className="flex">Delete</span>
                        </th>
                      </tr>
                    </thead>
                    <SortableContext
                      items={lfDiagTestQuestions.map((item) =>
                        item.liftOffDiagTestQuestionId.toString()
                      )}
                      strategy={verticalListSortingStrategy}
                    >
                      <tbody>
                        {lfDiagTestQuestions &&
                          lfDiagTestQuestions.map((item, index) => (
                            <StandardCardSortableItem
                              key={item.liftOffDiagTestQuestionId}
                              item={item}
                              index={index}
                              toggle={toggle}
                              handleShowGroupedStandards={
                                handleShowGroupedStandards
                              }
                              confirmDeleteQuestion={confirmDeleteQuestion}
                              groupedStandards={groupedStandards}
                            />
                          ))}
                      </tbody>
                    </SortableContext>
                  </table>
                </DndContext>
              </div>

              <div className="flex justify-between items-center m-4">
                {showSaveOrderFlag && (
                  <button
                    className="mt-2 inline-flex items-center float-right text-sm text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                    type="button"
                    onClick={() => {
                      handleSaveOrder();
                    }}
                  >
                    Save Order
                  </button>
                )}
              </div>
            </Fragment>
          )}
        </div>
      </div>

      {showStandardTestPopup && (
        <StandardTestPopup
          liftOffHeaderId={props.liftOffHeaderId}
          subjectId={props.subjectId}
          showPopup={setShowStandardTestPopup}
          saveTest={handleSaveQuestion}
          editFlag={false}
          loDiagnosticTestQuestions={lfDiagTestQuestions}
          liftOffDiagnosticTestID={props.liftOffDiagnosticTestId}
          testName={props.name}
        />
      )}

      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={() => {
            setShowDeleteModal(false);
          }}
          deleteRecord={handleDeleteQuestion}
        />
      )}

      {showDeleteTestModal && (
        <DeleteModal
          closeDeleteModal={() => {
            setShowDeleteTestModal(false);
          }}
          deleteRecord={handleDeleteTest}
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(StandardCard);
